import './LinkItemForm.css';

import React, { useEffect, useState } from 'react';
import { createItem, updateItem } from '../../../../services/b2b-logbook-apiServices';
import B2BFormContainer from '../../../b2b-common/B2BFormContainer';
import BooleanIconToggle from '../../../b2b-common/BooleanIconToggle';
import EditText from '../../../b2b-common/EditText';
import FieldComponent from '../../../b2b-common/FieldComponent';
import { showNotification } from '../../../b2b-common/Notification';
import { useLoginContext } from '../../../../App';
import { useContentContext } from '../../../layout/Layout';
import { Star, StarBorder } from '@mui/icons-material';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';

const LinkItemForm = ({ logbook, itemLink = null, folder, onClose, onSaved }) => {
    const { loginData } = useLoginContext();
    const { setNotification } = useContentContext();
    const { t } = useB2BTranslation('b2b-logbook');

    const blankLink = {
        logBookItemType: 'LINK',
        logBookId: logbook.logBookId,
        logBookFolderId: folder ? folder.logBookFolderId : 0,
        logBookItemId: 0,
        // logBook: logbook,
        // logBookFolder: folder ?? {},
        logBookItemCreationTime: new Date().toISOString(), // Converting to ISO string for LocalDateTime
        logBookItemName: `${t('New Link')}`,
        logBookItemDescription: '',
        logBookItemStarred: false,
        logBookItemLinkURL: ''
    }

    const [currentLink, setCurrentLink] = useState(itemLink || blankLink);

    useEffect(() => {
        if (itemLink) {
            setCurrentLink(itemLink);
        }
    }, [itemLink]);

    useEffect(() => {
        if (folder && (folder.logBookFolderId !== currentLink.logBookFolderId)) {
            setCurrentLink(currentLink => ({ ...currentLink, logBookFolderId: folder.logBookFolderId }));
        }
    }, [folder]);

    const handleSave = async () => {
        if (itemLink === null) { // Create
            try {
                const updatedItem = await createItem(loginData.accessToken, currentLink.logBookId, currentLink.logBookFolderId, currentLink);
                showNotification(setNotification, t('Link created successfully.'), 'success', 3000);
                onSaved && onSaved(updatedItem);
            } catch (error) {
                console.error('Error creating link:', error);
                showNotification(setNotification, t('Error creating link: ') + error.message, 'error', 5000);
            }
        } else { // Update
            try {
                const updatedItem = await updateItem(loginData.accessToken, currentLink.logBookId, currentLink.logBookFolderId, currentLink.logBookItemId, currentLink);
                showNotification(setNotification, t('Link updated successfully.'), 'success', 3000);
                onSaved && onSaved(updatedItem);
            } catch (error) {
                console.error('Error updating link:', error);
                showNotification(setNotification, t('Error updating link: ') + error.message, 'error', 5000);
            }
        }
    }

    return (
        <B2BFormContainer title={itemLink ? t('Edit Link') : t('New Link')} onClose={onClose} onSave={handleSave}
            showDivider={false}
            buttonsConfig={[
                { label: t('Save'), onClick: handleSave },
            ]}
            className='link-item-form'>
            <div>
                <EditText object={currentLink} objectField='logBookItemName' setObjectField={setCurrentLink} label={t('Link Name')} />
                <FieldComponent label={t('Favorite')} className={'link-item-starred-toggle'}
                    component={
                        <BooleanIconToggle
                            value={currentLink.logBookItemStarred}
                            trueIcon={<Star />}
                            falseIcon={<StarBorder />}
                            onChange={(value) => setCurrentLink({ ...currentLink, logBookItemStarred: value })}
                        />
                    }
                />
            </div>
            <EditText object={currentLink} objectField='logBookItemDescription' setObjectField={setCurrentLink} label={t('Link Description')} multiline={true} rows={3} />
            <EditText object={currentLink} objectField='logBookItemLinkURL' setObjectField={setCurrentLink} label={t('Link URL')} />
        </B2BFormContainer>
    );
}

export default LinkItemForm;